module.exports = __webpack_public_path__ + "img/voiceing.42d24b0f.png";